import { render, staticRenderFns } from "./diseaseclass.vue?vue&type=template&id=049b64d5"
import script from "./diseaseclass.vue?vue&type=script&lang=js"
export * from "./diseaseclass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049b64d5')) {
      api.createRecord('049b64d5', component.options)
    } else {
      api.reload('049b64d5', component.options)
    }
    module.hot.accept("./diseaseclass.vue?vue&type=template&id=049b64d5", function () {
      api.rerender('049b64d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicconfig/diseaseclass.vue"
export default component.exports